import { Row as RowI } from '@/types/components'

import { COMPONENTS } from '../ComponentsLayout/constants'

export type RowProps = Omit<
  RowI & {
    tabIndex: number
  },
  'componentType'
>

export const Row = ({ id, components, tabIndex }: RowProps) => {
  const componentsLength = components.length
  return (
    <div className="flex flex-row gap-4" data-testid={`row-${id}`}>
      {components.map((subComponent, index) => {
        const Component = COMPONENTS[subComponent.componentType]
        const subComponentTabIndex = Math.abs(tabIndex - componentsLength + index) + 1

        return (
          <span key={subComponent.id} className="flex-1">
            <Component {...subComponent} tabIndex={subComponentTabIndex} isInRow />
          </span>
        )
      })}
    </div>
  )
}
